module.exports = __webpack_public_path__ + "static/img/fish43.da5c59e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish43.png
// module id = XGAz
// module chunks = 0